module.exports = __webpack_public_path__ + "img/wifiOfficial.e9c18d60.jpg";